<template>
  <v-card elevation="0" :color="$vuetify.theme.dark ? 'transparent' : 'transparent'" class="pl-3 edit-news">
    <v-container class="custom-container responsive-height">
      <v-row>
        <v-col cols="12">
          <v-card-title class="pb-0">
            Configure & Update Your Server
          </v-card-title>
        </v-col>
        <v-col cols="12">
          <v-card class="deposit-form px-5" :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
            <v-row dense>
              <v-col cols="12" xl="7" lg="8" md="9" sm="10" class="mb-2">
                <fieldset>
                  <legend>Server</legend>
                  <v-text-field :disabled="$canRoute('server-configuration') !== 1" v-model="form.server" label="Server" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>
              <v-col cols="12" xl="7" lg="8" md="9" sm="10" class="mb-2">
                <fieldset>
                  <legend>Login</legend>
                  <v-text-field :disabled="$canRoute('server-configuration') !== 1" v-model="form.login" label="Login" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>
              <v-col cols="12" xl="7" lg="8" md="9" sm="10" class="mb-2">
                <fieldset>
                  <legend>Password</legend>
                  <v-text-field :disabled="$canRoute('server-configuration') !== 1" v-model="form.password" label="Password" type="password" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>
              <v-col cols="12" xl="7" lg="8" md="9" sm="10" class="mb-2">
                <fieldset>
                  <legend>Demo Server</legend>
                  <v-text-field :disabled="$canRoute('server-configuration') !== 1" v-model="form.demo_server" label="Demo Server" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>
              <v-col cols="12" xl="7" lg="8" md="9" sm="10" class="mb-2">
                <fieldset>
                  <legend>Demo Login</legend>
                  <v-text-field :disabled="$canRoute('server-configuration') !== 1" v-model="form.demo_login" label="Demo Login" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>
              <v-col cols="12" xl="7" lg="8" md="9" sm="10" class="mb-2">
                <fieldset>
                  <legend>Demo Password</legend>
                  <v-text-field :disabled="$canRoute('server-configuration') !== 1" v-model="form.demo_password" label="Demo Password" type="password" single-line solo
                    hide-details class="custom-select"></v-text-field>
                </fieldset>
              </v-col>
              <v-col cols="12" xl="7" lg="8" md="9" sm="10" class="mb-2">
                <fieldset>
                  <legend>Server for Client</legend>
                  <v-text-field :disabled="$canRoute('server-configuration') !== 1" v-model="form.server_name" label="Server Name" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>
              <v-col cols="12" xl="7" lg="8" md="9" sm="10" class="mb-2">
                <fieldset>
                  <legend>Demo Server for Client</legend>
                  <v-text-field :disabled="$canRoute('server-configuration') !== 1" v-model="form.demo_server_name" label="Demo Server Name" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>
              <v-col cols="12" xl="7" lg="8" md="9" sm="10" class="mb-2">
                <fieldset>
                  <legend>Windows Link</legend>
                  <v-text-field :disabled="$canRoute('server-configuration') !== 1" v-model="form.windows_download_link" label="Windows Download Link" single-line solo
                    hide-details class="custom-select"></v-text-field>
                </fieldset>
              </v-col>
              <v-col cols="12" xl="7" lg="8" md="9" sm="10" class="mb-2">
                <fieldset>
                  <legend>Android Download Link</legend>
                  <v-text-field :disabled="$canRoute('server-configuration') !== 1" v-model="form.android_download_link" label="Android Download Link" single-line solo
                    hide-details class="custom-select"></v-text-field>
                </fieldset>
              </v-col>
              <v-col cols="12" xl="7" lg="8" md="9" sm="10" class="mb-2">
                <fieldset>
                  <legend>IOS Download Link</legend>
                  <v-text-field :disabled="$canRoute('server-configuration') !== 1" v-model="form.ios_download_link" label="IOS Download Link" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col cols="12" v-if="$canRoute('server-configuration') === 1">
          <v-btn large tile elevation="0" class="ml-5 text-capitalize btn-account" color="greenMain"
            @click="submitForm">
            Submit
          </v-btn>
          <v-btn large tile elevation="0" class="ml-3 text-capitalize btn-account" color="#FF567F" @click="resetForm">
            Reset
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { SERVERCONFIG__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      form: {
        server: "",
        login: "",
        password: "",
        demo_server: "",
        demo_login: "",
        demo_password: "",
        server_name: "",
        demo_server_name: "",
        windows_download_link: "",
        android_download_link: "",
        ios_download_link: "",
      },
    };
  },
  computed: {
    ...mapState("serverconfig", ["s_config"]),
    ...mapState("admins", ["loggedAdmin"]),
  },
  methods: {
    ...mapActions("serverconfig", [
      SERVERCONFIG__ACTIONS.SERVERCONFIG,
      SERVERCONFIG__ACTIONS.UPDATESERVERCONFIG,
    ]),

    async submitForm() {
      try {
        this[SERVERCONFIG__ACTIONS.UPDATESERVERCONFIG]({
          server: this.form.server,
          login: this.form.login,
          password: this.form.password,
          demo_server: this.form.demo_server,
          demo_login: this.form.demo_login,
          demo_password: this.form.demo_password,
          server_name: this.form.server_name,
          demo_server_name: this.form.demo_server_name,
          windows_download_link: this.form.windows_download_link,
          android_download_link: this.form.android_download_link,
          ios_download_link: this.form.ios_download_link,
        });
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    },
    resetForm() {
      this.form = {
        server: "",
        login: "",
        password: "",
        demo_server: "",
        demo_login: "",
        demo_password: "",
        server_name: "",
        demo_server_name: "",
        windows_download_link: "",
        android_download_link: "",
        ios_download_link: "",
      };
    },
    populateForm() {
      if (this.s_config) {
        this.form = {
          server: this.s_config.server || "",
          login: this.s_config.login || "",
          password: this.s_config.password || "",
          demo_server: this.s_config.demo_server || "",
          demo_login: this.s_config.demo_login || "",
          demo_password: this.s_config.demo_password || "",
          server_name: this.s_config.server_name || "",
          demo_server_name: this.s_config.demo_server_name || "",
          windows_download_link: this.s_config.windows_download_link || "",
          android_download_link: this.s_config.android_download_link || "",
          ios_download_link: this.s_config.ios_download_link || "",
        };
      }
    },
  },

  async created() {
    await this[SERVERCONFIG__ACTIONS.SERVERCONFIG]();
    this.populateForm();
  },
};
</script>
